module.exports = __webpack_public_path__ + "img/huya.91f90478.png";